import { $t } from '@/i18n';
import { defineComponent, onMounted } from '@vue/composition-api';
import PermissionCheckbox from './PermissionCheckbox';
import { useBuiltinPermissionList } from './utils';
export default defineComponent({
    name: 'CustomPermission',
    emits: ['change'],
    props: {
        projectId: {
            type: String,
            default: '',
            required: true,
        },
        env: {
            type: String,
            default: 'dev',
        },
        role: {
            type: String,
            default: '',
            required: true,
        },
        permissions: {
            type: Array,
            required: true,
        },
        rolePerms: {
            type: Array,
            required: true,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        maxHeight: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        const { keyword, filterPermissions, fetchBuiltinPermissionList } = useBuiltinPermissionList(props.projectId);
        onMounted(() => fetchBuiltinPermissionList(props.env));
        return {
            keyword,
            filterPermissions,
            fetchBuiltinPermissionList,
        };
    },
    render() {
        const change = (e) => {
            const changePerm = e.data;
            const { permission } = changePerm;
            const builtin = this.filterPermissions.find(x => x.name === permission);
            if (builtin)
                changePerm.permName = builtin.cname;
            this.$emit('checkChange', e);
        };
        const columns = [
            {
                title: $t('k_f11e4084'),
                colKey: 'name',
                cell: (h, { row }) => (<span>
            {row.name.includes('.project') ? (<t-tooltip placement="right">
                <template slot="content">
                  <span>{$t('k_7935122')}</span>
                </template>
                <span>{row.name}</span>
                <t-icon name="info-circle" style="margin-left:8px"/>
              </t-tooltip>) : (row.name)}
          </span>),
            },
            {
                title: $t('k_a7974e2f'),
                colKey: 'cname',
            },
            {
                title: $t('k_80a2a191'),
                cell: (h, { row: record }) => (<PermissionCheckbox projectId={this.projectId} env={this.env} role={this.role} rolePerms={this.rolePerms} readonly={this.readonly} permission={record.name} onCheckChange={change} onChange={(v) => this.$emit('change', v)}/>),
            },
        ];
        return (<div>
        <div style="margin-bottom:12px">
          <t-input v-model={this.keyword} placeholder={$t('k_807a75bc')} style="width:240px">
            <t-icon slot="suffixIcon" name="search"/>
          </t-input>
        </div>
        <div>
          <t-table columns={columns} data={this.filterPermissions} rowKey="name" hover maxHeight={this.maxHeight} pagination={false} scroll={{ type: 'virtual' }}></t-table>
        </div>
      </div>);
    },
});
